export default "__VITE_ASSET__d378a746__"